import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-make-payment-status',
  templateUrl: './make-payment-status.component.html',
  styleUrls: ['./make-payment-status.component.scss']
})
export class MakePaymentStatusComponent implements OnInit {

  orderId: string;
  status: string;
  statusMessage: string;
  statusClass: string;


  attempt = 0;
  maxRetries = 6;

  retryDelayMs = 10000; // 10 sec
  totalTimeSeconds = (this.maxRetries * this.retryDelayMs) / 1000;

  remainingSeconds = this.totalTimeSeconds;
  progressPercent = 0;

  private timerInterval: any;

  private pollTimeout: any;
  private pollingSub!: Subscription;
  private destroyed = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiFactory: APIFactoryEndPoints,
    private userService: UserService
  ) { }

  ngOnInit() {
    // Get the query params from the URL
    this.route.queryParams.subscribe(params => {
      this.orderId = params['order_id'];
      // this.status = params['status'];

      // Set the message based on the status
      this.startVerification(this.orderId);
    });
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.stopAll();
  }


  startVerification(data: any) {
    if (!data) return;

    const transactionId = data;

    this.startTimer();

    const pollStatus = () => {
      if (this.destroyed) return; // ✅ prevent further calls

      this.attempt++;

      this.pollingSub = this.userService.getOrderDetailsByOrderNo(this.apiFactory.getCCAvenueResponseByOrderId, transactionId).subscribe({
        next: (resp: any) => {
          const ccStatus = resp?.order_status;
          if (ccStatus) {
            this.stopAll();
            this.status = ccStatus;
            this.setStatusMessage();
          } else {
            // If order_status is not present, we can decide to retry or show an error
            if (this.attempt < this.maxRetries) {
              this.pollTimeout = setTimeout(() => {
                if (!this.destroyed) {
                  pollStatus();
                }
              }, this.retryDelayMs);
            } else {
              this.stopAll();
              this.status = 'Unknown';
              this.setStatusMessage();
            }
          }
        },
        error: () => {
          if (this.attempt < this.maxRetries) {
            this.pollTimeout = setTimeout(() => {
              if (!this.destroyed) {
                pollStatus();
              }
            }, this.retryDelayMs);
          } else {
            this.stopAll();
          }
        }
      });
    };

    pollStatus();
  }

  setStatusMessage() {
    // Log the status to check for leading/trailing spaces
    console.log('Received status: ' + this.status);

    // Use trim() and convert to lowercase for consistent comparison
    const normalizedStatus = this.status.trim().toLowerCase();

    if (normalizedStatus === 'success') {
      this.statusMessage = 'Your payment was successful.';
      this.statusClass = 'success';
    } else if (normalizedStatus === 'failed') {
      this.statusMessage = 'Your payment has failed. Please try again.';
      this.statusClass = 'failed';
    } else {
      this.statusMessage = 'Unknown status. Please contact support.';
      this.statusClass = 'failed';
    }
  }

  startTimer() {
    this.remainingSeconds = this.totalTimeSeconds;
    this.progressPercent = 0;

    this.timerInterval = setInterval(() => {
      this.remainingSeconds--;

      this.progressPercent =
        ((this.totalTimeSeconds - this.remainingSeconds) /
          this.totalTimeSeconds) *
        100;

      if (this.remainingSeconds <= 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.timerInterval);
  }

  // ✅ Stop everything safely
  private stopAll() {
    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
    }

    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }

    this.stopTimer();
  }

  onTryAgain() {
    this.router.navigate(['/make-payment']);  // Navigate to the make-payment page
  }
}
